import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { VIEW_BY } from '../constant'
import { selectViewBy } from '../store/slice'
import { Chart } from './chart'
import { resetStore } from './store/slice'
import { getImportExportData } from './store/thunk'
import { Table } from './table'

export const ImportExport = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const viewBy = useSelector(selectViewBy)
  const locale = useSelector((state) => state.i18n.locale)

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    dispatch(getImportExportData({ OrganizationId: params.organizationId }))
  }, [locale, params.organizationId])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  return viewBy.value === VIEW_BY.CHART.value ? <Chart /> : <Table />
}
